'use client'

import { useEffect } from 'react'

export function DynamicFont({ fontFamily }: { fontFamily: string }) {
  useEffect(() => {
    const link = document.createElement('link')
    link.href = `https://fonts.googleapis.com/css?family=${fontFamily.replace(' ', '+')}`
    link.rel = 'stylesheet'
    document.head.appendChild(link)

    return () => {
      document.head.removeChild(link)
    }
  }, [fontFamily])

  return null
}